export default {
    loading: "načítání"
}